"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInboxCount = exports.GET_INBOX_COUNT = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var GET_INBOX_COUNT = "\n  query GetInboxCount($params: FilterParamsInput) {\n    count(params: $params)\n  }\n";
exports.GET_INBOX_COUNT = GET_INBOX_COUNT;

var getInboxCount = function getInboxCount(client) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params) {
      var _ref2, tenantId, rest, results;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (client) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", Promise.resolve());

            case 2:
              _ref2 = params || {}, tenantId = _ref2.tenantId, rest = (0, _objectWithoutProperties2["default"])(_ref2, ["tenantId"]);
              _context.next = 5;
              return client.query(GET_INBOX_COUNT, {
                params: _objectSpread(_objectSpread({}, rest), {}, {
                  // [HACK] map tenantId to accountId in order to keep this backwards compatible
                  accountId: tenantId
                })
              }).toPromise();

            case 5:
              results = _context.sent;
              return _context.abrupt("return", results === null || results === void 0 ? void 0 : results.data);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getInboxCount = getInboxCount;